import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { useSliderTimer } from "../utils/hooks/useSliderTimer";
export var useCarousel = function useCarousel(_ref) {
  var slidesLength = _ref.slidesLength;
  var isDesktop = useIsDesktopDimension();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    swiperInstance = _useState2[0],
    setSwiperInstance = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSlide = _useState4[0],
    setActiveSlide = _useState4[1];
  var _useSliderTimer = useSliderTimer({
      slidesCount: slidesLength,
      swiperInstance: swiperInstance
    }),
    activeIndex = _useSliderTimer.isActiveIndex,
    handleManualSlideChange = _useSliderTimer.handleManualSlideChange;
  var setInstance = useCallback(function (swiper) {
    setSwiperInstance(swiper);
    setActiveSlide(swiper.activeIndex + 1);
    handleManualSlideChange(swiper.activeIndex);
  }, [setSwiperInstance, setActiveSlide, handleManualSlideChange]);
  var nextSlide = useCallback(function () {
    return (swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext()) || function () {};
  }, [swiperInstance]);
  var prevSlide = useCallback(function () {
    return (swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev()) || function () {};
  }, [swiperInstance]);
  var handleChangeSlide = useCallback(function (slideIndex) {
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(activeIndex + 1);
    setActiveSlide(slideIndex + 1);
    handleManualSlideChange(slideIndex);
  }, [handleManualSlideChange, setActiveSlide, swiperInstance]);
  return {
    isDesktop: isDesktop,
    activeSlide: activeSlide,
    nextSlide: nextSlide,
    prevSlide: prevSlide,
    setInstance: setInstance,
    handleManualSlideChange: handleManualSlideChange,
    handleChangeSlide: handleChangeSlide,
    activeIndex: activeIndex
  };
};